import React, { useCallback, useEffect, useState } from "react";
import axios from "axios";

import "./CarpetaMedica.css";

import CarpetaForm from "./CarpetaForm";
import CarpetaExaminaForm from "./CarpetaExaminaForm";
import CadetesBuscadorPresente from "./CadetesBuscadorPresentes";
import ListeaCarpetas from "./ListeaCarpetas";
import ModalCreaCarpeta from "./Modal";

import CarpetaInfo from "../Sanidad/CarpetaInfo";

import ObtieneDatosCookies from "../obtieneDatosCookiesUsuario";
import comprueboPermisos from "../tools/comprueboPermisos";
import socket from "../tools/socke";

const API_BASE =
  "https://wwwa.isepsantafe.net.ar/expedientes/NCadetes";

const CarpetaMedica = () => {
  const Usuario = ObtieneDatosCookies();

  // ============================================================
  // DATOS
  // ============================================================

  const [
    carpetasMedicasSolicitados,
    setCarpetasMedicasSolicitados,
  ] = useState([]);

  const [
    carpetasMedicasFinalizados,
    setCarpetasMedicasFinalizados,
  ] = useState([]);

  const [
    carpetaFinalSeleccionada,
    setCarpetaFinalSeleccionada,
  ] = useState(null);

  const [nroId, setNroId] = useState(null);

  const [
    carpetaSeleccionada,
    setCarpetaSeleccionada,
  ] = useState(null);

  // ============================================================
  // MODALES
  // ============================================================

  const [
    modalCreaCarpeta,
    setModalCreaCarpeta,
  ] = useState(false);

  const [
    modalCreaCarpetaExamina,
    setModalCreaCarpetaExamina,
  ] = useState(false);

  const [
    verModalFinal,
    setModalFinal,
  ] = useState(false);

  // ============================================================
  // ESTADOS DE CARGA
  // ============================================================

  const [
    cargandoSolicitados,
    setCargandoSolicitados,
  ] = useState(true);

  const [
    cargandoFinalizados,
    setCargandoFinalizados,
  ] = useState(true);

  const [error, setError] = useState("");

  // ============================================================
  // PERMISOS
  // ============================================================

  const puedeCrear = comprueboPermisos(
    Usuario?.funcion,
    "Crea Reconocimientos"
  );

  const puedeCompletar = comprueboPermisos(
    Usuario?.funcion,
    "Completo Reconocimientos"
  );

  const esDireccion =
    Number(Usuario?.destino) === 7 ||
    comprueboPermisos(
      Usuario?.funcion,
      "Direccion Gral"
    ) ||
    comprueboPermisos(
      Usuario?.funcion,
      "Direccion EP"
    );

  const esCuerpo =
    Number(Usuario?.destino) === 20 ||
    Number(Usuario?.destino) === 35 ||
    comprueboPermisos(
      Usuario?.funcion,
      "Cuerpo"
    );

  const sedeUsuario =
    Number(Usuario?.sedeID) === 2
      ? "Rosario"
      : "Recreo";

  // ============================================================
  // OBTENER PENDIENTES
  // ============================================================

  const obtieneReconocimientosSolicitados =
    useCallback(async () => {
      try {
        setCargandoSolicitados(true);
        setError("");

        let sede = null;

        if (esDireccion) {
          sede = "todas";
        } else if (esCuerpo) {
          sede = sedeUsuario;
        }

        if (!sede) {
          setCarpetasMedicasSolicitados([]);
          return;
        }

        const response = await axios.post(
          `${API_BASE}/devuelveCarpetaMedicaACompletar/${sede}`
        );

        setCarpetasMedicasSolicitados(
          Array.isArray(response?.data)
            ? response.data
            : []
        );
      } catch (error) {
        console.error(
          "Error obteniendo reconocimientos pendientes:",
          error
        );

        setError(
          "No se pudieron obtener los reconocimientos médicos pendientes."
        );
      } finally {
        setCargandoSolicitados(false);
      }
    }, [
      esDireccion,
      esCuerpo,
      sedeUsuario,
    ]);

  // ============================================================
  // OBTENER FINALIZADOS
  // ============================================================

  const obtieneReconocimientosFinalizados =
    useCallback(async () => {
      try {
        setCargandoFinalizados(true);

        let sede = null;

        if (esDireccion) {
          sede = "todas";
        } else if (
          Number(Usuario?.destino) === 20 ||
          puedeCompletar ||
          comprueboPermisos(
            Usuario?.funcion,
            "Cuerpo"
          )
        ) {
          sede = sedeUsuario;
        }

        if (!sede) {
          setCarpetasMedicasFinalizados([]);
          return;
        }

        const response = await axios.post(
          `${API_BASE}/devuelveCarpetaMedicaFinalizadas/${sede}`
        );

        setCarpetasMedicasFinalizados(
          Array.isArray(response?.data)
            ? response.data
            : []
        );
      } catch (error) {
        console.error(
          "Error obteniendo reconocimientos finalizados:",
          error
        );

        setError(
          "No se pudieron obtener los reconocimientos médicos finalizados."
        );
      } finally {
        setCargandoFinalizados(false);
      }
    }, [
      esDireccion,
      Usuario?.destino,
      Usuario?.funcion,
      sedeUsuario,
      puedeCompletar,
    ]);

  // ============================================================
  // REFRESCAR TODO
  // ============================================================

  const refrescar = useCallback(() => {
    obtieneReconocimientosSolicitados();
    obtieneReconocimientosFinalizados();
  }, [
    obtieneReconocimientosSolicitados,
    obtieneReconocimientosFinalizados,
  ]);

  // ============================================================
  // CREAR CARPETA
  // ============================================================

  const inicioCarpeta = (cadete) => {
    setNroId(cadete);
    setModalCreaCarpeta(true);
  };

  // ============================================================
  // COMPLETAR CARPETA
  // ============================================================

  const completoCarpeta = (carpeta) => {
    if (!puedeCompletar) {
      return;
    }

    setCarpetaSeleccionada(carpeta);
    setModalCreaCarpetaExamina(true);

    socket.emit(
      "carpetaEvent",
      ""
    );
  };

  // ============================================================
  // CERRAR CREACION
  // ============================================================

  const manejaCerradoCarpetaForm = () => {
    setModalCreaCarpeta(false);
    setNroId(null);

    socket.emit(
      "carpetaEvent",
      ""
    );
  };

  // ============================================================
  // CERRAR EXAMEN
  // ============================================================

  const manejaCerradoCarpetaExaminaForm =
    () => {
      setModalCreaCarpetaExamina(false);
      setCarpetaSeleccionada(null);

      socket.emit(
        "carpetaEvent",
        ""
      );
    };

  // ============================================================
  // MOSTRAR INFORMACION FINALIZADA
  // ============================================================

  const handleMuestraInfo = (carpeta) => {
    setCarpetaFinalSeleccionada(
      carpeta
    );

    setModalFinal(true);
  };

  // ============================================================
  // SOCKET
  // ============================================================

  useEffect(() => {
    refrescar();

    const handleActualizarCarpetas = () => {
      refrescar();
    };

    socket.on(
      "ActualizarCarpetas",
      handleActualizarCarpetas
    );

    return () => {
      socket.off(
        "ActualizarCarpetas",
        handleActualizarCarpetas
      );
    };
  }, [refrescar]);

  // ============================================================
  // DATOS AUXILIARES
  // ============================================================

  const nombreCadeteCreacion =
    nroId
      ? `${nroId?.cadeteApellido || ""} ${
          nroId?.cadeteNombre || ""
        }`.trim()
      : "";

  const nombreCadeteExamen =
    carpetaSeleccionada?.cadete
      ? `${
          carpetaSeleccionada.cadete
            ?.cadeteApellido || ""
        } ${
          carpetaSeleccionada.cadete
            ?.cadeteNombre || ""
        }`
      : "";

  const dniCadeteExamen =
    carpetaSeleccionada?.cadete
      ?.cadeteDni || "";

  // ============================================================
  // RENDER
  // ============================================================

  return (
    <div className="cm-v2-page">
      <div className="cm-v2-container">

        {/* ==================================================== */}
        {/* CABECERA */}
        {/* ==================================================== */}

        <section className="cm-v2-header">
          <div>
            <span className="cm-v2-eyebrow">
              SANIDAD · ISeP
            </span>

            <h1 className="cm-v2-title">
              Reconocimientos Médicos
            </h1>

            <p className="cm-v2-subtitle">
              Gestión y seguimiento de
              reconocimientos médicos de
              cadetes.
            </p>
          </div>

          <button
            type="button"
            className="cm-v2-refresh"
            onClick={refrescar}
            disabled={
              cargandoSolicitados ||
              cargandoFinalizados
            }
          >
            <span>↻</span>

            {cargandoSolicitados ||
            cargandoFinalizados
              ? "Actualizando..."
              : "Actualizar"}
          </button>
        </section>

        {/* ==================================================== */}
        {/* ERROR */}
        {/* ==================================================== */}

        {error && (
          <div className="cm-v2-error">
            <div>
              <strong>
                No pudimos actualizar toda
                la información
              </strong>

              <span>{error}</span>
            </div>

            <button
              type="button"
              onClick={() => setError("")}
            >
              ×
            </button>
          </div>
        )}

        {/* ==================================================== */}
        {/* CREAR RECONOCIMIENTO */}
        {/* ==================================================== */}

        {puedeCrear && (
          <section className="cm-v2-create-card">
            <div className="cm-v2-create-info">
              <div className="cm-v2-create-icon">
                +
              </div>

              <div>
                <h2>
                  Nuevo reconocimiento
                </h2>

                <p>
                  Busque un cadete que se
                  encuentre presente para
                  iniciar el reconocimiento
                  médico.
                </p>
              </div>
            </div>

            <div className="cm-v2-search-box">
              <div className="cm-v2-search-label">
                Buscar cadete presente
              </div>

              <CadetesBuscadorPresente
                devuelvo={(cadete) =>
                  inicioCarpeta(cadete)
                }
              />
            </div>
          </section>
        )}

        {/* ==================================================== */}
        {/* RESUMEN */}
        {/* ==================================================== */}

        <section className="cm-v2-summary">
          <div className="cm-v2-stat-card cm-v2-stat-pending">
            <div className="cm-v2-stat-icon">
              ⏱
            </div>

            <div>
              <span className="cm-v2-stat-label">
                Pendientes
              </span>

              <strong>
                {cargandoSolicitados
                  ? "..."
                  : carpetasMedicasSolicitados.length}
              </strong>

              <small>
                Aguardando examen médico
              </small>
            </div>
          </div>

          <div className="cm-v2-stat-card cm-v2-stat-finished">
            <div className="cm-v2-stat-icon">
              ✓
            </div>

            <div>
              <span className="cm-v2-stat-label">
                Finalizados
              </span>

              <strong>
                {cargandoFinalizados
                  ? "..."
                  : carpetasMedicasFinalizados.length}
              </strong>

              <small>
                Últimos 7 días
              </small>
            </div>
          </div>
        </section>

        {/* ==================================================== */}
        {/* PENDIENTES */}
        {/* ==================================================== */}

        <section className="cm-v2-section">
          <div className="cm-v2-section-header">
            <div className="cm-v2-section-title-group">
              <div className="cm-v2-section-indicator cm-v2-section-indicator-pending" />

              <div>
                <h2>
                  Reconocimientos pendientes
                </h2>

                <p>
                  Solicitudes que todavía
                  requieren evaluación médica.
                </p>
              </div>
            </div>

            <span className="cm-v2-counter cm-v2-counter-pending">
              {
                carpetasMedicasSolicitados.length
              }
            </span>
          </div>

          <div className="cm-v2-section-content">
            {cargandoSolicitados ? (
              <div className="cm-v2-loading">
                <div className="cm-v2-spinner" />

                <span>
                  Obteniendo reconocimientos
                  pendientes...
                </span>
              </div>
            ) : carpetasMedicasSolicitados.length >
              0 ? (
              <div className="cm-v2-list-wrapper">
                <ListeaCarpetas
                  paso={1}
                  carpetas={
                    carpetasMedicasSolicitados
                  }
                  onClick={(carpeta) =>
                    completoCarpeta(carpeta)
                  }
                  carpetaFinal={() => {}}
                />
              </div>
            ) : (
              <div className="cm-v2-empty">
                <div className="cm-v2-empty-icon">
                  ✓
                </div>

                <strong>
                  Sin reconocimientos
                  pendientes
                </strong>

                <span>
                  No existen solicitudes
                  pendientes para examinar.
                </span>
              </div>
            )}
          </div>
        </section>

        {/* ==================================================== */}
        {/* FINALIZADOS */}
        {/* ==================================================== */}

        <section className="cm-v2-section">
          <div className="cm-v2-section-header">
            <div className="cm-v2-section-title-group">
              <div className="cm-v2-section-indicator cm-v2-section-indicator-finished" />

              <div>
                <h2>
                  Reconocimientos finalizados
                </h2>

                <p>
                  Reconocimientos completados
                  durante los últimos 7 días.
                </p>
              </div>
            </div>

            <span className="cm-v2-counter cm-v2-counter-finished">
              {
                carpetasMedicasFinalizados.length
              }
            </span>
          </div>

          <div className="cm-v2-section-content">
            {cargandoFinalizados ? (
              <div className="cm-v2-loading">
                <div className="cm-v2-spinner" />

                <span>
                  Obteniendo reconocimientos
                  finalizados...
                </span>
              </div>
            ) : carpetasMedicasFinalizados.length >
              0 ? (
              <div className="cm-v2-list-wrapper cm-v2-list-finished">
                <ListeaCarpetas
                  paso={2}
                  carpetas={
                    carpetasMedicasFinalizados
                  }
                  onClick={() => {}}
                  carpetaFinal={(carpeta) =>
                    handleMuestraInfo(
                      carpeta
                    )
                  }
                />
              </div>
            ) : (
              <div className="cm-v2-empty">
                <div className="cm-v2-empty-icon">
                  ⏱
                </div>

                <strong>
                  Sin registros recientes
                </strong>

                <span>
                  No existen reconocimientos
                  finalizados durante los
                  últimos 7 días.
                </span>
              </div>
            )}
          </div>
        </section>
      </div>

      {/* ====================================================== */}
      {/* MODAL CREAR RECONOCIMIENTO */}
      {/* ====================================================== */}

      {modalCreaCarpeta && nroId && (
        <ModalCreaCarpeta
          isOpen={modalCreaCarpeta}
          onClose={
            manejaCerradoCarpetaForm
          }
        >
          <div className="cm-v2-modal-content">
            <div className="cm-v2-modal-header">
              <span className="cm-v2-modal-eyebrow">
                NUEVO RECONOCIMIENTO
              </span>

              <h3>
                Crear Reconocimiento Médico
              </h3>

              <div className="cm-v2-modal-person">
                <div className="cm-v2-avatar">
                  {nroId?.cadeteApellido
                    ?.charAt(0)
                    ?.toUpperCase() ||
                    nroId?.cadeteNombre
                      ?.charAt(0)
                      ?.toUpperCase() ||
                    "C"}
                </div>

                <div>
                  <strong>
                    {nombreCadeteCreacion}
                  </strong>

                  <span>
                    DNI{" "}
                    {nroId?.cadeteDni ||
                      "-"}
                  </span>
                </div>
              </div>
            </div>

            <div className="cm-v2-modal-body">
              <CarpetaForm
                cadete={nroId}
                onClose={
                  manejaCerradoCarpetaForm
                }
              />
            </div>
          </div>
        </ModalCreaCarpeta>
      )}

      {/* ====================================================== */}
      {/* MODAL EXAMEN */}
      {/* ====================================================== */}

      {modalCreaCarpetaExamina &&
        carpetaSeleccionada && (
          <ModalCreaCarpeta
            isOpen={
              modalCreaCarpetaExamina
            }
            onClose={
              manejaCerradoCarpetaExaminaForm
            }
          >
            <div className="cm-v2-modal-content cm-v2-modal-exam">
              <div className="cm-v2-modal-header">
                <span className="cm-v2-modal-eyebrow">
                  EXAMEN MÉDICO
                </span>

                <h3>
                  Evaluación del cadete
                </h3>

                <div className="cm-v2-modal-person">
                  <div className="cm-v2-avatar">
                    {carpetaSeleccionada
                      ?.cadete
                      ?.cadeteApellido
                      ?.charAt(0)
                      ?.toUpperCase() ||
                      "C"}
                  </div>

                  <div>
                    <strong>
                      {
                        nombreCadeteExamen
                      }
                    </strong>

                    <span>
                      DNI{" "}
                      {dniCadeteExamen}
                    </span>
                  </div>
                </div>
              </div>

              <div className="cm-v2-modal-body">
                <CarpetaExaminaForm
                  cadete={
                    carpetaSeleccionada
                  }
                  onClose={
                    manejaCerradoCarpetaExaminaForm
                  }
                />
              </div>
            </div>
          </ModalCreaCarpeta>
        )}

      {/* ====================================================== */}
      {/* MODAL INFORMACION FINAL */}
      {/* ====================================================== */}

      {verModalFinal &&
        carpetaFinalSeleccionada && (
          <ModalCreaCarpeta
            isOpen={verModalFinal}
            onClose={() => {
              setModalFinal(false);

              setCarpetaFinalSeleccionada(
                null
              );
            }}
          >
            <div className="cm-v2-modal-content cm-v2-info-modal">
              <div className="cm-v2-modal-header">
                <span className="cm-v2-modal-eyebrow">
                  RECONOCIMIENTO FINALIZADO
                </span>

                <h3>
                  Información del
                  reconocimiento
                </h3>
              </div>

              <div className="cm-v2-modal-body">
                <CarpetaInfo
                  datos={
                    carpetaFinalSeleccionada
                  }
                />
              </div>
            </div>
          </ModalCreaCarpeta>
        )}
    </div>
  );
};

export default CarpetaMedica;